<template>
    <div class="sidebar" data-color="white" data-active-color="danger">
        <div class="logo">
            <router-link :to="{name: 'dashboard'}" class="simple-text logo-normal" exact>
                <div class="logo-image-small">
                    <img src="../assets/image/title-logo.png"  alt=""/>
                </div>
            </router-link>
        </div>
        <div class="sidebar-wrapper ps-container ps-theme-default">
            <ul class="nav">
                <router-link v-for="(item, index) in links" :key="index" :to="item.url" tag="li">
                    <a>
                        <i :class="item.icon_class"/>
                        <p>{{$t(item.title)}}</p>
                    </a>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import { ROLE } from "../const/role";

export default {
    data() {
        return {
            links: [
            ]
        };
    },
    methods: {
    },
    created() {
        let links =  [
            { title: "common.dashboard", url: "/dashboard", icon_class: "nc-icon nc-layout-11" },
            { title: "common.aimodel", url: "/aimodel", icon_class: "nc-icon nc-app" },
            { title: "common.users", url: "/users", icon_class: "nc-icon nc-single-02" },
        ];

        // if user is admin, show organization and subscription menu
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.admin === ROLE.ROLE_USER_ADMIN) {
            links.push({ title: "common.organization", url: "/organization", icon_class: "nc-icon nc-alert-circle-i" });
            links.push({ title: "common.subscription", url: "/subscription", icon_class: "nc-icon nc-cart-simple" });
        }
        this.links = links;
    }
};
</script>


<style lang="scss" scoped>
  @import '../assets/sass/layout/sidebar.scss';
</style>
